"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
var NativeString_1 = __importDefault(require("./NativeString"));
/** StarkString constructor */
function starkString(value) {
    if (typeof value === "number" || typeof value === "string")
        value = String(value);
    else if (Array.isArray(value))
        value = value.join("");
    else if (value === undefined || value === null)
        value = "";
    else
        throw new Error("StarkString value must be type of string, number or Array<string|number> instead of ".concat(typeof value));
    return new StarkString(value);
}
var StarkString = /** @class */ (function (_super) {
    __extends(StarkString, _super);
    function StarkString(value) {
        return _super.call(this, value) || this;
    }
    /** Returns a copy of a StarkString Object */
    StarkString.prototype.clone = function () {
        return starkString(this._value);
    };
    /** Used for set new string */
    StarkString.prototype.set = function (value) {
        this._value = String(value);
        return this;
    };
    /** Used for convert Arabic characters to Persian */
    StarkString.prototype.persianChar = function () {
        this._value = (0, core_1.persianChar)(this.toString());
        return this;
    };
    /** Used for convert any numbers to English */
    StarkString.prototype.englishNumber = function () {
        this._value = (0, core_1.englishNumber)(this._value);
        return this;
    };
    /** Used for convert Arabic numbers to Persian */
    StarkString.prototype.persianNumber = function () {
        this._value = (0, core_1.persianNumber)(this._value);
        return this;
    };
    /** Used for convert English numbers to arabic */
    StarkString.prototype.arabicNumber = function () {
        this._value = (0, core_1.arabicNumber)(this._value);
        return this;
    };
    /**
     * Used for Normalize url
     * https://fa.wikipedia.org/wiki/مدیاویکی:Gadget-Extra-Editbuttons-Functions. s
     */
    StarkString.prototype.fixURL = function () {
        if (!this._value) {
            return this;
        }
        if (/^(wss?(:|\/))/i.test(this._value)) {
            this._value = this._value.replace(/^(ws)?(s)?(:*)(\/+)?/i, "ws$2://");
        }
        else if (/^(ftps?(:|\/))/i.test(this._value)) {
            this._value = this._value.replace(/^(ftp)?(s)?(:*)(\/+)?/i, "ftp$2://");
        }
        else {
            this._value = this._value.replace(/^(http)?(s)?(:*)(\/+)?/i, "http$2://");
        }
        this._value = this._value.replace(/(\/?)$/i, "/");
        return this;
    };
    /**
     * Used for decode Persian Characters in URL
     * https://fa.wikipedia.org/wiki/مدیاویکی:Gadget-Extra-Editbuttons-Functions. s
     */
    StarkString.prototype.decodeURL = function () {
        this._value = (0, core_1.decodeURL)(this._value);
        return this;
    };
    /** Used for Change keyboard layout */
    StarkString.prototype.switchKey = function () {
        this._value = (0, core_1.switchKey)(this._value);
        return this;
    };
    /** Used for get persian words representation of a number */
    StarkString.prototype.digitsToWords = function () {
        this._value = (0, core_1.digitsToWords)(this._value);
        return this;
    };
    /** Used for Zero-width non-joiner correction */
    StarkString.prototype.halfSpace = function () {
        this._value = (0, core_1.halfSpace)(this._value);
        return this;
    };
    /** Return true if value is Integer */
    StarkString.prototype.isInteger = function () {
        return (0, core_1.isInteger)(this._value);
    };
    /** Used for validation back card number */
    StarkString.prototype.isValidBankCard = function () {
        return (0, core_1.isValidBankCard)(this._value);
    };
    /** Used for convert to price mode */
    StarkString.prototype.toCurrency = function (formatCurrency) {
        if (formatCurrency === void 0) { formatCurrency = false; }
        this._value = (0, core_1.toCurrency)(this._value, formatCurrency);
        return this;
    };
    /** Remove anything expect numbers */
    StarkString.prototype.parseNumber = function (options) {
        this.englishNumber();
        this._value = (0, core_1.toNumber)(this._value, options);
        return this;
    };
    /** Convert any char to star ("*") */
    StarkString.prototype.security = function () {
        this._value = (0, core_1.security)(this._value);
        return this;
    };
    /** Convert any string to number */
    StarkString.prototype.toStringNumber = function (options) {
        this.parseNumber(options);
        return this._value;
    };
    /**
     * Precision decimal number with all number length for
     *
     * @example
     *   starkString(`12.3456`).paddingDecimal(3); //`12.3`
     *   starkString(`123456`).paddingDecimal(3); //`123456`
     */
    StarkString.prototype.toDecimalPrecision = function (allLength) {
        this._value = (0, core_1.toDecimalPrecision)(this._value, allLength);
        return this;
    };
    /** Convert any string to number */
    StarkString.prototype.toNumber = function (options) {
        this.parseNumber(options);
        return Number(this._value);
    };
    /**
     * Convert to string representing a number in fixed-point notation.
     *
     * @param value
     * @param fractionDigits — Number of digits after the decimal point. Must be
     *   in the range 0 - 20, inclusive.
     */
    StarkString.prototype.toFixed = function (fractionDigits) {
        this._value = (0, core_1.toFixed)(this._value, fractionDigits);
        return this;
    };
    /**
     * Convert to string representing a number in fixed-point notation and trim .
     *
     * @param value
     * @param fractionDigits — Number of digits after the decimal point. Must be
     *   in the range 0 - 20, inclusive.
     */
    StarkString.prototype.toFixedNumber = function (fractionDigits) {
        this._value = Number((0, core_1.toFixed)(this._value, fractionDigits)).toString();
        return this;
    };
    StarkString.prototype.floor = function () {
        this._value = (0, core_1.floor)(this._value);
        return this;
    };
    return StarkString;
}(NativeString_1.default));
// eslint-disable-next-line no-extend-native
Object.defineProperties(String.prototype, {
    starkString: {
        get: function () {
            return starkString(this);
        },
    },
});
//Expose StarkString
//CommonJS module is defined
exports.default = starkString;
//# sourceMappingURL=index.js.map